// src/data/exerciseData.js
import logo from '../assets/Logo.jpeg'

export const exercises = [
{
videoSrc: "https://res.cloudinary.com/dulyuapuk/video/upload/v1762425817/Cardio_Circuit_nxjtod.mp4",
thumbnailSrc: logo, // This will be replaced by dynamic thumbnails
thumbnailTimestamp: 8, // Frame at 8 seconds
title: 'Cardio Circuit 1',
description: 'A great starting point for mobility and strength building from the comfort of your chair.',
duration: '1 min 8 sec',
difficulty: 'Intermediate',
category: 'Chair Exercises'
},
{
videoSrc: "https://res.cloudinary.com/dulyuapuk/video/upload/v1762425510/Cut_The_Fruit_tbn5zf.mp4",
thumbnailSrc: logo,
thumbnailTimestamp: 5,
title: 'Cut The Fruit',
description: 'Seated twisting and stretching exercise to improve flexibility, coordination, and posture.',
duration: '20 sec',
difficulty: 'Beginner',
category: 'Wellness, Beat, Breath, Injury Prevention',
goalIntent: ['Increase Mobility', 'Increase Energy', 'Improve Coordination', 'Strengthen Core', 'Improve Flexibility'],
symptomFeeling: ['Stiffness', 'Back Pain', 'Poor Posture', 'Fatigue / Low Energy', 'Dizziness / Vertigo'],
bodyPart: ['Full Body', 'Spine / Back', 'Shoulders', 'Core', 'Obliques', 'Arms'],
activityContext: ['Senior Fitness', 'Chair Exercises', 'Gardening', 'Household Chores', 'Morning Routine', 'Warm-up'],
exerciseType: ['Mobility', 'Stretching', 'Core Stability', 'Chair Exercises', 'Breathing Exercises', 'Coordination'],
difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Senior-Friendly', 'Adaptable Intensity']
},

{
videoSrc: "https://res.cloudinary.com/dulyuapuk/video/upload/v1762425538/Down-Then-Up_ksodkp.mp4",
thumbnailSrc: logo,
thumbnailTimestamp: 6,
title: 'Down-Then-Up',
description: 'Mobility and posture exercise to reduce stiffness, improve breathing, and increase energy.',
duration: '44 sec',
difficulty: 'Beginner',
category: 'Wellness, Pain Management, Breath, Aspirational Goal',
goalIntent: ['Reduce Stiffness', 'Increase Flexibility', 'Increase Energy', 'Improve Breathing', 'Improve Posture'],
symptomFeeling: ['Back Stiffness', 'Lower Back Pain', 'Upper Back Pain', 'Slumped Posture', 'Lethargy'],
bodyPart: ['Spine', 'Full Body', 'Lower Back', 'Upper Back', 'Shoulders'],
activityContext: ['Morning Routine', 'Senior Fitness', 'Office Break', 'Warm-up', 'Relaxation'],
exerciseType: ['Mobility', 'Stretching', 'Chair Exercises', 'Breathing Exercises', 'Flexibility'],
difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Senior-Friendly', 'Rehab']
},
{
videoSrc: "https://res.cloudinary.com/dulyuapuk/video/upload/v1762425487/Forward_and_Back_gfkoef.mp4",
thumbnailSrc: logo,
thumbnailTimestamp: 7,
title: 'Forward and Back',
description: 'Seated forward and back exercise to build core stability, balance, and leg strength.',
duration: '18 sec',
difficulty: 'Beginner',
category: 'Wellness, Injury Prevention, Falls Prevention, Balance, Beat',
goalIntent: ['Strengthen Legs', 'Improve Balance', 'Strengthen Core', 'Prepare for Activity'],
symptomFeeling: ['Weakness', 'Poor Balance', 'Fear of Falling', 'Difficulty Walking', 'Hip Pain / Stiffness'],
bodyPart: ['Hips', 'Legs', 'Core', 'Knee', 'Abs / Tummy'],
activityContext: ['Walking', 'Stair Climbing', 'Senior Fitness', 'Chair Exercises', 'Getting Up from a Chair'],
exerciseType: ['Strengthening', 'Balance Training', 'Chair Exercises', 'Core Stability', 'Cardio (Light)'],
difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Rehab', 'Senior-Friendly']
},

{
videoSrc: "https://res.cloudinary.com/dulyuapuk/video/upload/v1762425440/Heel-Toe_djzdh9.mp4",
thumbnailSrc: logo,
thumbnailTimestamp: 4,
title: 'Heel-Toe',
description: 'Gentle heel-toe exercise to improve circulation, reduce stiffness, and support ankle mobility.',
duration: '22 sec',
difficulty: 'Beginner',
category: 'Wellness, Pain Management, Injury Prevention, Post Operation',
goalIntent: ['Improve Circulation', 'Improve Mobility', 'Reduce Swelling', 'Reduce Stiffness', 'Prepare for Activity'],
symptomFeeling: ['Ankle Stiffness', 'Foot Pain', 'Poor Circulation', 'Swollen Ankles', 'Leg Cramps'],
bodyPart: ['Ankles', 'Feet', 'Lower Legs', 'Calves', 'Shins'],
activityContext: ['Senior Fitness', 'Prolonged Sitting', 'Walking', 'TV Watching', 'Travel'],
exerciseType: ['Mobility', 'Chair Exercises', 'Stretching', 'Warm-up', 'Rehab'],
difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Rehab', 'Senior-Friendly']
},
{
videoSrc: "https://res.cloudinary.com/dulyuapuk/video/upload/v1762425612/Inhale-Exhale_gktalv.mp4",
thumbnailSrc: logo,
thumbnailTimestamp: 10,
title: 'Inhale-Exhale',
description: 'Gentle breathing exercise to improve lung function, reduce stress, and support relaxation.',
duration: '21 sec',
difficulty: 'Beginner',
category: 'Breath, Wellness',
goalIntent: ['Improve Breathing', 'Reduce Stress', 'Relaxation', 'Improve Mobility', 'Increase Energy'],
symptomFeeling: ['Shallow Breathing', 'Breathlessness', 'Anxiety'],
bodyPart: ['Shoulders', 'Upper Back', 'Chest', 'Lungs', 'Full Body'],
activityContext: ['Morning Routine', 'Relaxation', 'Senior Fitness', 'Office Break', 'Desk Job'],
exerciseType: ['Breathing Exercises', 'Chair Exercises', 'Warm-up'],
difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Senior-Friendly']
},
{
videoSrc: "https://res.cloudinary.com/dulyuapuk/video/upload/v1762425421/Inhale-Exhale-Push_xvgxw5.mp4",
thumbnailSrc: logo,
thumbnailTimestamp: 6,
title: 'Inhale-Exhale-Push',
description: 'Controlled breathing and light arm push exercise to relax the body, improve focus, and boost circulation.',
duration: '21 sec',
difficulty: 'Beginner',
category: 'Breath, Wellness, Pain Management, Beat',
goalIntent: ['Improve Breathing', 'Relaxation / Stress Relief', 'Increase Energy', 'Improve Focus / Mindfulness', 'Strengthen Upper Body'],
symptomFeeling: ['Stress / Anxiety', 'Breathlessness', 'Fatigue / Low Energy', 'Poor Circulation', 'Tension'],
bodyPart: ['Lungs / Diaphragm', 'Chest', 'Shoulders', 'Upper Back', 'Core', 'Arms'],
activityContext: ['Breathing Practice', 'Meditation / Mindfulness', 'Senior Fitness', 'Chair Exercises', 'Warm-up', 'Cool-down', 'Office Exercises'],
exerciseType: ['Breathing Exercises', 'Mindful Movement', 'Stretching', 'Strengthening', 'Chair Exercises'],
difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Senior-Friendly', 'Adaptable Intensity']
},

{
videoSrc: "https://res.cloudinary.com/dulyuapuk/video/upload/v1762425520/Knee_Straighten_hpfajt.mp4",
thumbnailSrc: logo,
thumbnailTimestamp: 8,
title: 'Knee Straighten',
description: 'Seated knee extension exercise to strengthen thighs, support knees, and reduce pain.',
duration: '24 sec',
difficulty: 'Beginner',
category: 'Pain Management, Injury Prevention, Post Operation',
goalIntent: ['Strengthen Legs', 'Reduce Pain', 'Support Knees', 'Prepare for Activity', 'Improve Balance'],
symptomFeeling: ['Knee Pain', 'Arthritis', 'Weakness', 'Unstable Knees', 'Difficulty Walking'],
bodyPart: ['Knee', 'Thighs', 'Legs', 'Core'],
activityContext: ['Knee Rehab', 'Senior Fitness', 'Stair Climbing', 'Walking', 'Getting Up From a Chair'],
exerciseType: ['Strengthening', 'Chair Exercises', 'Mobility'],
difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Senior-Friendly']
},
{
videoSrc: "https://res.cloudinary.com/dulyuapuk/video/upload/v1762425471/Neck_Circle_z1idwa.mp4",
thumbnailSrc: logo,
thumbnailTimestamp: 6,
title: 'Neck Circles',
description: 'Circular neck movements to relieve stiffness, reduce tension, and increase flexibility.',
duration: '19 sec',
difficulty: 'Beginner',
category: 'Wellness, Pain Management, Injury Prevention',
goalIntent: ['Reduce Stiffness', 'Increase Mobility', 'Reduce Pain', 'Relaxation'],
symptomFeeling: ['Neck Pain', 'Stiffness', 'Tension', 'Headaches', 'Dizziness / Vertigo'],
bodyPart: ['Neck', 'Shoulders', 'Cervical Spine'],
activityContext: ['Desk Work Relief', 'Reading Relief', 'Phone Use Relief', 'Morning Routine', 'Bedtime Routine', 'Senior Fitness', 'Office Exercises'],
exerciseType: ['Mobility', 'Stretching', 'Chair Exercises'],
difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Senior-Friendly']
},

/*
{
videoSrc: "x",
thumbnailSrc: logo,
thumbnailTimestamp: 12,
title: 'Out And In',
description: 'Gentle hip-opening and closing exercise to improve mobility, reduce stiffness, and support hip strength.',
duration: '19 sec',
difficulty: 'Beginner',
category: 'Wellness, Pain Management, Injury Prevention, Breath, Beat',
goalIntent: ['Increase Mobility', 'Reduce Stiffness', 'Strengthen Legs', 'Prepare for Activity'],
symptomFeeling: ['Hip Pain', 'Stiffness', 'Weakness', 'Arthritis', 'Groin Pain'],
bodyPart: ['Hips', 'Inner Thigh / Groin', 'Outer Thigh / Hips', 'Pelvis', 'Legs'],
activityContext: ['Senior Fitness', 'Chair Exercises', 'Sitting on Floor', 'Getting out of a Car', 'Warm-up', 'Desk Work Relief'],
exerciseType: ['Mobility', 'Stretching', 'Strengthening', 'Chair Exercises', 'Bodyweight Exercise', 'Breathing Exercises', 'Cardio (Light)'],
difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Rehab', 'Senior-Friendly']
},
*/

{
videoSrc: "https://res.cloudinary.com/dulyuapuk/video/upload/v1762425509/Sciatic_Nerve_Flossing_ogmqfg.mp4",
thumbnailSrc: logo,
thumbnailTimestamp: 5,
title: 'Sciatic Nerve Flossing',
description: 'Gentle nerve gliding exercise to improve mobility, reduce stiffness, and relieve sciatica pain.',
duration: '28 sec',
difficulty: 'Beginner',
category: 'Pain Management, Wellness, Injury Prevention',
goalIntent: ['Reduce Pain', 'Improve Nerve Mobility', 'Reduce Stiffness', 'Desensitise Nerve'],
symptomFeeling: ['Sciatica', 'Nerve Pain', 'Tingling / Numbness', 'Hamstring Tightness', 'Lower Back Pain', 'Leg Pain'],
bodyPart: ['Sciatic Nerve', 'Legs', 'Hamstrings', 'Lower Back', 'Nerves', 'Neck'],
activityContext: ['Senior Fitness', 'Chair Exercises', 'Pain Relief Routine', 'Sitting for Long Periods', 'Rehab'],
exerciseType: ['Nerve Flossing / Gliding', 'Mobility', 'Therapeutic Exercise', 'Chair Exercises', 'Bodyweight Exercise'],
difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Rehab', 'Senior-Friendly']
},

{
videoSrc: "https://res.cloudinary.com/dulyuapuk/video/upload/v1762425551/Hamstring_Stretch_d0q5hg.mp4",
thumbnailSrc: logo,
thumbnailTimestamp: 9,
title: 'Hamstring Stretch',
description: 'Stretch your hamstrings and lower back to reduce stiffness, improve flexibility, and support posture.',
duration: '53 sec',
difficulty: 'Beginner',
category: 'Pain Management, Wellness, Injury Prevention, Aspirational Goal',
goalIntent: ['Increase Flexibility', 'Reduce Pain', 'Reduce Stiffness', 'Prepare for Activity', 'Improve Posture'],
symptomFeeling: ['Lower Back Pain', 'Stiffness', 'Tight Hamstrings', 'Leg Pain', 'Difficulty Bending'],
bodyPart: ['Hamstrings', 'Lower Back', 'Legs', 'Knee', 'Calves'],
activityContext: ['Senior Fitness', 'Gardening', 'Walking', 'Cool-down', 'Sitting on Floor'],
exerciseType: ['Stretching', 'Chair Exercises', 'Flexibility', 'Mobility', 'Cool-down'],
difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Rehab', 'Senior-Friendly']
},

{
videoSrc: "https://res.cloudinary.com/dulyuapuk/video/upload/v1762425521/Seated_Marching_bumw5z.mp4",
thumbnailSrc: logo,
thumbnailTimestamp: 4,
title: 'Seated Marching',
description: 'Light seated marching to strengthen legs, improve circulation, and stay active while sitting.',
duration: '12 sec',
difficulty: 'Beginner',
category: 'Wellness, Injury Prevention',
goalIntent: ['Strengthen Legs', 'Improve Circulation', 'Stay Active While Sitting', 'Prepare for Activity', 'Increase Energy'],
symptomFeeling: ['Weakness', 'Stiffness', 'Poor Circulation', 'Leg Pain', 'Arthritis'],
bodyPart: ['Legs', 'Hips', 'Knees', 'Core', 'Thighs'],
activityContext: ['Senior Fitness', 'Prolonged Sitting', 'Walking', 'Stair Climbing', 'TV Watching'],
exerciseType: ['Strengthening', 'Cardio (Light)', 'Chair Exercises', 'Mobility', 'Warm-up'],
difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Rehab', 'Senior-Friendly']
},
{
videoSrc: "https://res.cloudinary.com/dulyuapuk/video/upload/v1762425405/Seated_Running_z3askm.mp4",
thumbnailSrc: logo,
thumbnailTimestamp: 15,
title: 'Seated Running',
description: 'Light seated running motion to improve heart health, boost energy, and enhance circulation.',
duration: '8 sec',
difficulty: 'Beginner',
category: 'Wellness, Beat, Injury Prevention, Breath',
goalIntent: ['Increase Energy', 'Improve Heart Health', 'Improve Circulation', 'Prepare for Activity'],
symptomFeeling: ['Breathlessness', 'Weakness', 'Fatigue / Low Energy', 'Knee Pain / Arthritis', 'Poor Circulation'],
bodyPart: ['Full Body', 'Legs', 'Arms', 'Core', 'Heart / Lungs'],
activityContext: ['Senior Fitness', 'Chair Exercises', 'Warm-up', 'Office Exercises', 'Indoor Activity', 'No-Impact Cardio'],
exerciseType: ['Cardio (Light)', 'Chair Exercises', 'Warm-up Exercise', 'Bodyweight Exercise', 'Coordination'],
difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Senior-Friendly', 'Adaptable Intensity']
},

{
videoSrc: "https://res.cloudinary.com/dulyuapuk/video/upload/v1762425395/Shoulder_Rolls_eeubk3.mp4",
thumbnailSrc: logo,
thumbnailTimestamp: 6,
title: 'Shoulder Rolls',
description: 'Gentle rolling of the shoulders to release tension, improve mobility, and reduce pain.',
duration: '13 sec',
difficulty: 'Beginner',
category: 'Wellness, Pain Management, Injury Prevention, Breath',
goalIntent: ['Reduce Stiffness', 'Increase Mobility', 'Reduce Pain', 'Relaxation', 'Improve Posture'],
symptomFeeling: ['Shoulder Pain', 'Neck Pain', 'Upper Back Pain', 'Stiffness', 'Tension', 'Poor Posture'],
bodyPart: ['Shoulders', 'Neck', 'Upper Back', 'Scapula / Shoulder Blade'],
activityContext: ['Desk Work Relief', 'Morning Routine', 'Warm-up', 'Senior Fitness', 'Office Exercises', 'Sitting for Long Periods'],
exerciseType: ['Mobility', 'Stretching', 'Chair Exercises', 'Warm-up Exercise', 'Bodyweight Exercise'],
difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Rehab', 'Senior-Friendly']
},

{
videoSrc: "https://res.cloudinary.com/dulyuapuk/video/upload/v1762425523/Turn_and_Hold_y9ozpe.mp4",
thumbnailSrc: logo,
thumbnailTimestamp: 10,
title: 'Turn and Hold',
description: 'Seated spinal rotation exercise to reduce stiffness, improve posture, and support mobility.',
duration: '33 sec',
difficulty: 'Beginner',
category: 'Wellness, Pain Management, Injury Prevention, Aspirational Goal',
goalIntent: ['Improve Mobility', 'Reduce Stiffness', 'Reduce Pain', 'Improve Posture', 'Prepare for Activity'],
symptomFeeling: ['Back Stiffness', 'Lower Back Pain', 'Mid Back Pain', 'Upper Back Pain', 'Waist Stiffness', 'Slumped Posture'],
bodyPart: ['Spine', 'Upper Back', 'Mid Back', 'Lower Back', 'Core', 'Waist'],
activityContext: ['Senior Fitness', 'Office Break', 'Driving', 'Household Chores', 'Warm-up'],
exerciseType: ['Mobility', 'Stretching', 'Chair Exercises', 'Flexibility', 'Core Exercise'],
difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Senior-Friendly', 'Rehab']
},

{
videoSrc: "https://res.cloudinary.com/dulyuapuk/video/upload/v1762425498/Turn_and_Hug_czb8ba.mp4",
thumbnailSrc: logo,
thumbnailTimestamp: 4,
title: 'Turn and Hug',
description: 'Gentle seated torso rotation and hugging stretch to reduce stiffness and improve posture.',
duration: '30 sec',
difficulty: 'Beginner',
category: 'Wellness, Pain Management, Injury Prevention, Breath, Beat',
goalIntent: ['Increase Mobility', 'Reduce Stiffness', 'Improve Posture', 'Relaxation'],
symptomFeeling: ['Upper Back Pain', 'Shoulder Pain', 'Stiffness', 'Poor Posture / Slouching', 'Tension'],
bodyPart: ['Spine / Back', 'Shoulders', 'Chest', 'Core', 'Obliques'],
activityContext: ['Senior Fitness', 'Chair Exercises', 'Desk Work Relief', 'Morning Routine', 'Warm-up', 'Reaching Behind'],
exerciseType: ['Mobility', 'Stretching', 'Core Stability', 'Chair Exercises', 'Breathing Exercises'],
difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Rehab', 'Senior-Friendly']
},

{
videoSrc: "https://res.cloudinary.com/dulyuapuk/video/upload/v1762562419/Split_Step_Calf_Raise_xt9ctd.mp4",
thumbnailSrc: logo,
thumbnailTimestamp: 4,
title: 'Split Step Calf Raise',
description: 'Gentle seated torso rotation and hugging stretch to reduce stiffness and improve posture.',
duration: '30 sec',
difficulty: 'Beginner',
category: ['Strengthening', 'Falls Prevention', 'Balance', 'Wellness', 'Injury Prevention'],
goalIntent: ['Strengthen Legs', 'Strengthen Ankles', 'Improve Balance', 'Improve Stability', 'Improve Circulation', 'Maintain Independence'],
symptomFeeling: ['Poor Balance', 'Weakness', 'Ankle Instability', 'Fear of Falling', 'Poor Circulation', 'Leg Cramps', 'Unsteady Gait'],
bodyPart: ['Calves / Lower Legs', 'Ankles', 'Feet'],
activityContext: ['Walking', 'Stair Climbing', 'Senior Fitness', 'Home Exercises', 'Balance Training', 'Rehab'],
exerciseType: ['Strengthening', 'Balance Training', 'Bodyweight Exercise', 'Supported Exercise', 'Calf Raise', 'Split Stance / Staggered Stance'],
difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Rehab', 'Senior-Friendly']
},
{
videoSrc: "https://res.cloudinary.com/dulyuapuk/video/upload/v1762562413/Side_to_step_opp._hand_up_xu0mic.mp4",
thumbnailSrc: logo,
thumbnailTimestamp: 4,
title: 'Leg to side + opposite arm up',
description: 'Gentle seated torso rotation and hugging stretch to reduce stiffness and improve posture.',
duration: '30 sec',
difficulty: 'Beginner',
category: ['Falls Prevention', 'Balance', 'Strengthening', 'Wellness', 'Injury Prevention', 'Stretching'],
goalIntent: ['Improve Balance', 'Improve Coordination', 'Strengthen Hips', 'Improve Stability', 'Maintain Independence', 'Increase Mobility', 'Gentle Side Stretch'],
symptomFeeling: ['Poor Balance', 'Unsteady Gait', 'Fear of Falling', 'Weakness', 'Hip Instability', 'Side Body Stiffness', 'Core Weakness'],
bodyPart: ['Full Body', 'Hips', 'Outer Thigh / Hips', 'Core', 'Obliques / Side Body', 'Shoulders', 'Legs'],
activityContext: ['Walking', 'Reaching', 'Senior Fitness', 'Home Exercises', 'Balance Training', 'Rehab', 'Daily Living Activities'],
exerciseType: ['Balance Training', 'Coordination', 'Strengthening', 'Stretching', 'Supported Exercise', 'Bodyweight Exercise', 'Lateral Movement / Side Step'],
difficultyIntensity: ['Beginner', 'Low-Impact', 'Senior-Friendly', 'Rehab', 'Adaptable Intensity']
},
{
videoSrc: "https://res.cloudinary.com/dulyuapuk/video/upload/v1762562398/Tandem_Stance_b4w7dw.mp4",
thumbnailSrc: logo,
thumbnailTimestamp: 4,
title: 'Tandem Stance',
description: 'Gentle seated torso rotation and hugging stretch to reduce stiffness and improve posture.',
duration: '30 sec',
difficulty: 'Beginner',
category: ['Falls Prevention', 'Balance', 'Strengthening', 'Wellness', 'Injury Prevention'],
goalIntent: ['Improve Balance', 'Improve Stability', 'Maintain Independence', 'Improve Coordination', 'Strengthen Ankles', 'Strengthen Core', 'Improve Proprioception (Body Awareness)'],
symptomFeeling: ['Poor Balance', 'Unsteady Gait', 'Fear of Falling', 'Ankle Instability', 'Dizziness / Vertigo'],
bodyPart: ['Full Body', 'Ankles', 'Feet', 'Legs', 'Core'],
activityContext: ['Senior Fitness', 'Home Exercises', 'Balance Training', 'Rehab', 'Daily Living Activities', 'Walking (Heel-to-Toe)'],
exerciseType: ['Balance Training', 'Static Hold / Isometric', 'Bodyweight Exercise', 'Supported Exercise'],
difficultyIntensity: ['Beginner (with support)', 'Low-Impact', 'Senior-Friendly', 'Rehab', 'Adaptable Difficulty']
},
{
videoSrc: "https://res.cloudinary.com/dulyuapuk/video/upload/v1762562392/Balance__High_Knee_Opp._Hand_frzlxw.mp4",
thumbnailSrc: logo,
thumbnailTimestamp: 4,
title: 'Balance High Knee Opposite Hand',
description: 'Gentle seated torso rotation and hugging stretch to reduce stiffness and improve posture.',
duration: '30 sec',
difficulty: 'Beginner',
category: ['Falls Prevention', 'Balance', 'Strengthening', 'Wellness', 'Injury Prevention', 'Stretching'],
goalIntent: ['Improve Balance', 'Improve Coordination', 'Strengthen Hips', 'Improve Stability', 'Maintain Independence', 'Increase Mobility', 'Gentle Side Stretch'],
symptomFeeling: ['Poor Balance', 'Unsteady Gait', 'Fear of Falling', 'Weakness', 'Hip Instability', 'Side Body Stiffness', 'Core Weakness'],
bodyPart: ['Full Body', 'Hips', 'Outer Thigh / Hips', 'Core', 'Obliques / Side Body', 'Shoulders', 'Legs'],
activityContext: ['Walking', 'Reaching', 'Senior Fitness', 'Home Exercises', 'Balance Training', 'Rehab', 'Daily Living Activities'],
exerciseType: ['Balance Training', 'Coordination', 'Strengthening', 'Stretching', 'Supported Exercise', 'Bodyweight Exercise', 'Lateral Movement / Side Step'],
difficultyIntensity: ['Beginner', 'Low-Impact', 'Senior-Friendly', 'Rehab', 'Adaptable Intensity']
},
{
videoSrc: "https://res.cloudinary.com/dulyuapuk/video/upload/v1762562445/Squat_rcmkdg.mp4",
thumbnailSrc: logo,
thumbnailTimestamp: 4,
title: 'Squat',
description: 'Gentle seated torso rotation and hugging stretch to reduce stiffness and improve posture.',
duration: '30 sec',
difficulty: 'Beginner',
category: ['Strengthening', 'Wellness', 'Falls Prevention', 'Injury Prevention', 'Balance'],
goalIntent: ['Strengthen Legs', 'Strengthen Hips', 'Improve Functional Movement', 'Maintain Independence', 'Improve Balance'],
symptomFeeling: ['Weakness', 'Difficulty Getting Up', 'Poor Balance', 'Fear of Falling', 'Knee Pain / Arthritis', 'Hip Pain'],
bodyPart: ['Legs', 'Thighs / Quads', 'Glutes / Bottom', 'Hips', 'Knees'],
activityContext: ['Getting Up from a Chair', 'Senior Fitness', 'Home Exercises', 'Balance Training', 'Daily Living Activities', 'Rehab'],
exerciseType: ['Strengthening', 'Functional Exercise', 'Squat', 'Bodyweight Exercise', 'Supported Exercise', 'Balance Training'],
difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Senior-Friendly', 'Rehab']
},
{
videoSrc: "https://res.cloudinary.com/dulyuapuk/video/upload/v1762562432/Calf_Raise_hdgqbh.mp4",
thumbnailSrc: logo,
thumbnailTimestamp: 4,
title: 'Calf Raise',
description: 'Gentle seated torso rotation and hugging stretch to reduce stiffness and improve posture.',
duration: '30 sec',
difficulty: 'Beginner',
category: ['Strengthening', 'Falls Prevention', 'Balance', 'Wellness', 'Injury Prevention'],
goalIntent: ['Strengthen Legs', 'Strengthen Ankles', 'Improve Balance', 'Improve Circulation', 'Maintain Independence'],
symptomFeeling: ['Poor Balance', 'Weakness', 'Ankle Instability', 'Fear of Falling', 'Poor Circulation', 'Leg Cramps'],
bodyPart: ['Calves / Lower Legs', 'Ankles', 'Feet'],
activityContext: ['Walking', 'Stair Climbing', 'Reaching', 'Senior Fitness', 'Home Exercises', 'Balance Training', 'Rehab'],
exerciseType: ['Strengthening', 'Balance Training', 'Bodyweight Exercise', 'Supported Exercise'],
difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Rehab', 'Senior-Friendly']
},
{
videoSrc: "https://res.cloudinary.com/dulyuapuk/video/upload/v1762562428/Split_Step_Squat_fllo4e.mp4",
thumbnailSrc: logo,
thumbnailTimestamp: 4,
title: 'Split Step Squat',
description: 'Gentle seated torso rotation and hugging stretch to reduce stiffness and improve posture.',
duration: '30 sec',
difficulty: 'Beginner',
category: ['Strengthening', 'Falls Prevention', 'Balance', 'Wellness', 'Injury Prevention'],
goalIntent: ['Strengthen Legs', 'Strengthen Hips', 'Improve Balance', 'Improve Stability', 'Maintain Independence', 'Improve Functional Movement'],
symptomFeeling: ['Weakness', 'Poor Balance', 'Fear of Falling', 'Knee Pain / Arthritis', 'Hip Pain', 'Difficulty Walking', 'Difficulty Climbing Stairs'],
bodyPart: ['Legs', 'Thighs / Quads', 'Glutes / Bottom', 'Hips', 'Knees'],
activityContext: ['Stair Climbing', 'Walking', 'Senior Fitness', 'Home Exercises', 'Balance Training', 'Rehab', 'Daily Living Activities'],
exerciseType: ['Strengthening', 'Balance Training', 'Functional Exercise', 'Bodyweight Exercise', 'Supported Exercise', 'Split Stance / Staggered Stance', 'Lunge (Modified)'],
difficultyIntensity: ['Beginner', 'Low-Impact', 'Senior-Friendly', 'Rehab', 'Adaptable Difficulty']
},
{
videoSrc: "https://res.cloudinary.com/dulyuapuk/video/upload/v1762562446/Step_to_side_Knee_bend_q3vld9.mp4",
thumbnailSrc: logo,
thumbnailTimestamp: 4,
title: 'Step to side + knee bend',
description: 'Gentle seated torso rotation and hugging stretch to reduce stiffness and improve posture.',
duration: '30 sec',
difficulty: 'Beginner',
category: ['Strengthening', 'Falls Prevention', 'Balance', 'Wellness', 'Injury Prevention'],
goalIntent: ['Strengthen Legs', 'Strengthen Hips', 'Improve Balance', 'Improve Stability', 'Maintain Independence', 'Improve Coordination'],
symptomFeeling: ['Poor Balance', 'Unsteady Gait', 'Fear of Falling', 'Weakness', 'Hip Instability', 'Difficulty Moving Sideways', 'Knee Pain / Arthritis'],
bodyPart: ['Hips', 'Outer Thigh / Hips', 'Inner Thigh / Groin', 'Glutes / Bottom', 'Thighs / Quads', 'Knees', 'Legs'],
activityContext: ['Walking', 'Navigating Crowds', 'Stepping Over Obstacles', 'Senior Fitness', 'Home Exercises', 'Balance Training', 'Rehab', 'Daily Living Activities'],
exerciseType: ['Strengthening', 'Balance Training', 'Functional Exercise', 'Supported Exercise', 'Bodyweight Exercise', 'Lateral Movement / Side Step'],
difficultyIntensity: ['Gentle', 'Beginner', 'Low-Impact', 'Senior-Friendly', 'Rehab']
}

];